import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../../helpers/utilities';
import ErrorBoundary from '../../../layouts/Portal/ErrorBoundary';

const Products = lazyWithRetry(() => import('./pages/Products'));
const ProductCreate = lazyWithRetry(() => import('./pages/ProductCreate'));
const ProductEdit = lazyWithRetry(() => import('./pages/ProductEdit'));

type Props = RouteComponentProps;

const ProductRoutes: React.FC<React.PropsWithChildren<Props>> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="product">
      <Switch>
        <Route
          exact
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <Products />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/create-product`}
          render={(routeProps) => (
            <LazyComponent>
              <ProductCreate {...routeProps} />
            </LazyComponent>
          )}
        />
        <Route
          exact
          path={`${path}/:productId`}
          render={(routeProps) => (
            <LazyComponent>
              <ProductEdit {...routeProps} />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default ProductRoutes;
